import React, {
  useState,
  useMemo,
  useCallback,
  useRef,
  useEffect,
} from "react";
import { Layout } from "../../containers";
import { UpgradeContainer } from "../../components";
import { Link, useLocation } from "react-router-dom";
import { CanvasElement } from "../../components";
import secureLocalStorage from "react-secure-storage";
import { addModal } from "../../lib/addModal";
import firebase from "../../lib/fire";
import {
  Container,
  ToolbarWindow,
  DropBoard,
  Tool,
  TopbarWindow,
  PopupContainer,
} from "./styled";
import { defaultItems } from "../../lib/defaultItems";
import { editItems } from "../../lib/editItems";

const DndDashboard = () => {
  const userLocal = secureLocalStorage.getItem("userLocal");
  const sessionUser = sessionStorage.getItem("user");
  const [items, setItems] = useState(defaultItems);
  const [isPopupActive, setIsPopupActive] = useState(true);
  const [toolMenuVisible, setToolMenuVisible] = useState(false);
  const [toolMenuPosition, setToolMenuPosition] = useState({ x: 0, y: 0 });
  const [optionsMenuActive, setOptionsMenuActive] = useState(false);
  const [optionsIdActive, setOptionsIdActive] = useState(null);
  const [dataForm, setDataForm] = useState({
    name: null,
    description: "",
    data: [],
  });
  const [droppedItems, setDroppedItems] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [size, setSize] = useState({ width: 800, height: 600 });
  const [touchStartTime, setTouchStartTime] = useState(null);
  const [touchTimer, setTouchTimer] = useState(null);
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const location = useLocation();
  let slug = location.pathname.replace("/app/edit-dashboard/", "");

  function updateForm(value) {
    return setDataForm((prev) => {
      return { ...prev, ...value };
    });
  }

  const calculateMaxHeight = (data) => {
    return Math.max(...data.map((item) => item.y + item.height)) + 250;
  };
  const calculateMaxWidth = (data) => {
    return Math.max(...data.map((item) => item.x + item.width)) + 250;
  };

  useEffect(() => {
    window.scrollTo(0, 1);
    if (slug !== null && slug !== undefined && slug !== "/app/dnd-dashboard") {
      const dashboard = userLocal?.analyticsBoards[slug];
      if (dashboard?.data) {
        Object.values(dashboard?.data).forEach((element) => {
          const item = items.find(
            (item) => item.id === element.id.split("-")[0]
          );

          const newItem = {
            ...item,
            id: element.id,
            x: element.x,
            y: element.y,
            width: element.width,
            height: element.height,
            listType: element.listType,
            data: element.id.includes("Table")
              ? element.tableData
              : element.id.includes("ComparisonBarChart")
              ? element.selectedOption
              : element.id.includes("Featured")
              ? element.selectedOption
              : element.id.includes("Note")
              ? element.noteContent
              : element.id.includes("Title")
              ? element.titleContent
              : null,
          };

          setDroppedItems((prevState) => [...prevState, newItem]);
        });
        updateForm({
          name: dashboard.name,
          description: dashboard.description,
        });
      }
    }
  }, [slug]);

  const generateUniqueId = useCallback(
    (baseId) => {
      const existingIds = droppedItems
        .map((item) => item.id)
        .filter((id) => id.startsWith(`${baseId}-`))
        .map((id) => parseInt(id.split(`${baseId}-`)[1], 10));

      const nextNumber =
        existingIds.length > 0 ? Math.max(...existingIds) + 1 : 1;

      return `${baseId}-${nextNumber}`;
    },
    [droppedItems]
  );

  const handleDragStart = useCallback((e, itemId) => {
    e.dataTransfer.setData("itemId", itemId);
    e.dataTransfer.effectAllowed = "move";
  }, []);

  const handleDrop = useCallback(
    (e) => {
      e.preventDefault();
      const itemId = e.dataTransfer.getData("itemId");
      const draggedItem = items.find((item) => item.id === itemId);
      if (draggedItem) {
        const boardElement = e.currentTarget;
        const rect = boardElement.getBoundingClientRect();

        const x = e.clientX - rect.left + boardElement.scrollLeft;
        const y = e.clientY - rect.top + boardElement.scrollTop;
        setDroppedItems((prevState) => [
          ...prevState,
          {
            ...draggedItem,
            id: generateUniqueId(draggedItem.id),
            x,
            y,
            width: draggedItem.width ? draggedItem.width : 200,
            height: draggedItem.height ? draggedItem.height : 200,
          },
        ]);
      }
    },
    [items, generateUniqueId]
  );

  const handleDragOver = useCallback((e) => {
    e.preventDefault();
    const { clientX, clientY } = e;

    if (contentRef.current) {
      const boardRect = contentRef.current.getBoundingClientRect();
      const containerRect = containerRef.current.getBoundingClientRect();
      const rightEdgeDistance = boardRect.right - clientX;

      if (rightEdgeDistance < 250) {
        const currentScrollLeft = containerRef.current.scrollLeft;
        const currentWidth = Number.parseInt(
          contentRef.current.style.width || boardRect.width
        );
        const newWidth = currentWidth + 250;

        contentRef.current.style.width = `${newWidth}px`;

        // Ajustar el scroll para mantener la posición relativa
        const scrollAdjustment = (newWidth - currentWidth) / 2;
        containerRef.current.scrollLeft = currentScrollLeft + scrollAdjustment;
      }
    }

    setSize((prev) => ({
      width: clientX > prev.width - 250 ? prev.width + 250 : prev.width,
      height: clientY > prev.height - 10 ? prev.height + 100 : prev.height,
    }));
  }, []);

  const handleMouseDown = useCallback(
    (e, id) => {
      const startX = e.clientX;
      const startY = e.clientY;
      const element = droppedItems.find((item) => item.id === id);
      const startLeft = element.x;
      const startTop = element.y;

      const el = document.getElementById(element.id);
      const onMouseMove = (moveEvent) => {
        el.classList.add("draggingActive");
        const dx = moveEvent.clientX - startX;
        const dy = moveEvent.clientY - startY;

        setDroppedItems((prev) =>
          prev.map((item) =>
            item.id === id
              ? { ...item, x: startLeft + dx, y: startTop + dy }
              : item
          )
        );
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
        el.classList.remove("draggingActive");
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    [droppedItems]
  );

  const handleTouchStart = useCallback(
    (e, id) => {
      const touch = e.touches[0];
      const startX = touch.clientX;
      const startY = touch.clientY;
      const element = droppedItems.find((item) => item.id === id);
      const startLeft = element.x;
      const startTop = element.y;
      const el = document.getElementById(element.id);
      setTouchStartTime(Date.now());

      if (touchTimer) {
        clearTimeout(touchTimer);
      }

      const timer = setTimeout(() => {
        setIsDragging(true);
        if (el) {
          el.classList.add("longPressActive");
        }
      }, 1000);

      setTouchTimer(timer);

      const onTouchMove = (moveEvent) => {
        const moveTouch = moveEvent.touches[0];
        const dx = moveTouch.clientX - startX;
        const dy = moveTouch.clientY - startY;
        const touchDuration = Date.now() - touchStartTime;

        if (isDragging && touchDuration >= 1000) {
          moveEvent.preventDefault();
          if (el) {
            el.classList.add("draggingActive");
          }
          setDroppedItems((prev) =>
            prev.map((item) =>
              item.id === id
                ? { ...item, x: startLeft + dx, y: startTop + dy }
                : item
            )
          );
        }
      };

      const onTouchEnd = () => {
        clearTimeout(touchTimer);
        setIsDragging(false);
        if (el) {
          el.classList.remove("draggingActive");
          el.classList.remove("longPressActive");
        }
        document.removeEventListener("touchmove", onTouchMove);
        document.removeEventListener("touchend", onTouchEnd);
      };

      document.addEventListener("touchmove", onTouchMove, {
        passive: !isDragging,
      });
      document.addEventListener("touchend", onTouchEnd);
    },
    [droppedItems, isDragging, touchStartTime, touchTimer]
  );
  const handleResize = useCallback((id, width, height) => {
    setDroppedItems((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          let newWidth = width;
          let newHeight = height;

          if (id.includes("Image")) {
            if (width / height !== item.aspectRatio) {
              if (width / item.aspectRatio > height) {
                newWidth = height * item.aspectRatio;
              } else {
                newHeight = width / item.aspectRatio;
              }
            }
            return {
              ...item,
              width: newWidth,
              height: newHeight,
            };
          }

          return { ...item, width: newWidth, height: newHeight };
        }
        return item;
      })
    );
  }, []);

  const handleImageSize = useCallback(({ event, id }) => {
    event.preventDefault();
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);

      const img = new Image();
      img.onload = () => {
        const newDimensions = {
          width: img.naturalWidth,
          height: img.naturalHeight,
        };

        setDroppedItems((prev) =>
          prev.map((item) => {
            if (item.id === id) {
              let newWidth = newDimensions.width;
              let newHeight = newDimensions.height;

              return {
                ...item,
                width: newWidth,
                height: newHeight,
                aspectRatio: newWidth / newHeight,
              };
            }
            return item;
          })
        );

        if (typeof onImageLoad === "function") {
        }
      };
      img.src = imageUrl;
    }
  }, []);

  const memoizedDroppedItems = useMemo(() => droppedItems, [droppedItems]);

  useEffect(() => {
    if (contentRef.current && memoizedDroppedItems.length > 0) {
      const newWidth = calculateMaxWidth(memoizedDroppedItems);
      contentRef.current.style.width = `${newWidth}px`;
    }
  }, [memoizedDroppedItems]);
  const handleSave = useCallback(() => {
    const savedItems = memoizedDroppedItems.map((item) => {
      const { id, x, y, width, height, content } = item;
      let additionalData = {};

      if (id.includes("Table")) {
        const tableElement = document.querySelector(`#${id} table`);
        if (tableElement) {
          const tableData = Array.from(tableElement.rows).map((row) =>
            Array.from(row.cells).map((cell) => cell.textContent)
          );
          additionalData.tableData = tableData;
        }
      } else if (id.includes("Note")) {
        const noteElement = document.querySelector(`#${id} [contenteditable]`);
        if (noteElement) {
          const noteContent = noteElement.innerHTML
            .split("<br>")
            .map((item) => item.trim())
            .filter(Boolean);
          additionalData.noteContent = noteContent;
          additionalData.listType = item.listType || null;
        }
      } else if (id.includes("Title")) {
        const titleElement = document.querySelector(`#${id} p`);
        if (titleElement) {
          additionalData.titleContent = titleElement.innerText;
        }
      } else if (id.includes("Featured")) {
        const selectElement = document.querySelector(`#${id} select`);
        const tableElement = document.querySelector(`#${id} table`);
        if (selectElement) {
          additionalData.selectedOption = selectElement.value;
        }
        if (tableElement) {
          const tableData = Array.from(tableElement.rows).map((row) =>
            Array.from(row.cells).map((cell) => cell.textContent)
          );
          additionalData.tableData = tableData;
        }
      } else if (
        content &&
        content.type &&
        content.type.name === "ComparisonBarChart"
      ) {
        const selectElement = document.querySelector(`#${id} select`);
        if (selectElement) {
          additionalData.selectedOption = selectElement.value;
        }
      }

      return {
        id,
        x,
        y,
        width,
        height,
        ...additionalData,
      };
    });
    localStorage.setItem("savedDashboardItems", JSON.stringify(savedItems));

    const userId = secureLocalStorage.getItem("userId");
    let user = JSON.parse(sessionUser) || {};
    if (!user.analyticsBoards) {
      user.analyticsBoards = {};
    }

    let PlayID;
    if (
      JSON.parse(sessionUser).analyticsBoards != null &&
      JSON.parse(sessionUser).analyticsBoards != undefined &&
      slug === "/app/dnd-dashboard"
    )
      PlayID = Object.keys(user.analyticsBoards).length;
    else if (slug !== "/app/dnd-dashboard") PlayID = slug;
    else PlayID = 0;

    if (!Array.isArray(user.analyticsBoards)) {
      user.analyticsBoards = [];
    }

    const newBoard = {
      name: dataForm.name,
      description: dataForm.description,
      data: savedItems,
    };

    if (slug !== "/app/dnd-dashboard") {
      user.analyticsBoards[slug] = newBoard;
    } else {
      user.analyticsBoards.push(newBoard);
    }

    firebase
      .database()
      .ref(`/users/0/${userId}/analyticsBoards/${PlayID}`)
      .set({
        name: dataForm.name,
        description: dataForm.description,
        data: savedItems,
      })
      .then(async () => {
        await sessionStorage.setItem("user", JSON.stringify(user));
        secureLocalStorage.setItem("user", user);
        secureLocalStorage.setItem("userLocal", user);
        addModal({
          modal: "SuccessModal",
          linkTo: `/app/analytics-dashboard`,
        });
      })
      .catch((error) => {
        console.error("Error saving dashboard:", error);
        addModal({ modal: "ErrorModal", linkTo: `/app/analytics-dashboard` });
      });
  }, [memoizedDroppedItems, dataForm, sessionUser]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (dataForm.name !== null) {
      setIsPopupActive(false);
    } else {
      document.getElementById("name-error").style.display = "flex";
    }
  };

  const handleRightClick = (e, itemId) => {
    e.preventDefault();

    const isTouchEvent = e.type === "touchstart";
    const x = isTouchEvent ? e.touches[0].pageX : e.pageX;
    const y = isTouchEvent ? e.touches[0].pageY : e.pageY;

    setToolMenuPosition({ x, y, itemId });
    setToolMenuVisible(true);
  };

  const handleClickOutside = () => {
    setToolMenuVisible(false);
  };

  const handleLeftClick = (e, item) => {
    e.preventDefault();
    if (
      item.id.includes("Note") ||
      (item.id.includes("Image") && item.aspectRatio !== undefined)
    ) {
      setOptionsMenuActive(!optionsMenuActive);
      setOptionsIdActive(item.id);
    }
  };

  const handleAddRowColumnTable = useCallback(
    (e, type) => {
      e.preventDefault();
      setDroppedItems((prev) =>
        prev.map((item) => {
          if (item.id === toolMenuPosition.itemId) {
            if (type === "row") {
              const newRows = item.rows + 1;
              const updatedContent = React.cloneElement(item.content, {
                rows: newRows,
                data: Array.from({ length: item.rows }, () =>
                  Array(item.columns).fill("")
                ),
              });

              return {
                ...item,
                rows: newRows,
                content: updatedContent,
                data: updatedContent.data,
                height: (item.height / item.rows) * newRows,
              };
            } else if (type === "column") {
              const newColumns = item.columns + 1;
              const updatedContent = React.cloneElement(item.content, {
                cols: newColumns,
                data: Array.from({ length: item.rows }, () =>
                  Array(item.columns).fill("")
                ),
              });

              return {
                ...item,
                content: updatedContent,
                columns: newColumns,
                width: (item.width / item.columns) * newColumns,
              };
            }
            return item;
          }
          return item;
        })
      );
    },
    [toolMenuPosition.itemId]
  );

  const handleEditOption = (e, label) => {
    e.preventDefault();
    if (optionsIdActive.includes("Note")) {
      setDroppedItems((prev) =>
        prev.map((item) =>
          item.id === optionsIdActive ? { ...item, listType: label } : item
        )
      );
    }
  };

  if (
    sessionUser === undefined ||
    sessionUser === null ||
    JSON.parse(sessionUser) === null ||
    JSON.parse(sessionUser).plan === "Basic"
  )
    return (
      <Layout>
        <UpgradeContainer />
      </Layout>
    );
  if (
    isPopupActive &&
    sessionUser !== undefined &&
    sessionUser !== null &&
    JSON.parse(sessionUser).plan !== "Basic"
  ) {
    return (
      <Layout>
        <PopupContainer>
          <div className="flex_center_space-between  create-board">
            <div className="flex_center_space-between  create-board_header">
              <button className="btn-primary ghost">
                <Link to="/app/analytics-dashboard">X</Link>
              </button>
              <h3>Crear plantilla</h3>
              <div className="form-group">
                <input
                  type="submit"
                  value="Guardar"
                  className="btn btn-primary"
                  onClick={(e) => {
                    handleSubmit(e);
                  }}
                />
              </div>
            </div>
            <div className="create-routine_form_container">
              <form>
                <div className="form-group">
                  <label>Nombre</label>
                  <input
                    required
                    onChange={(e) => updateForm({ name: e.target.value })}
                    value={dataForm.name}
                  />
                  <p
                    id="name-error"
                    style={{
                      display: "none",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "0.2rem",
                      marginBottom: "1rem",
                    }}
                  >
                    EL NOMBRE ES OBLIGATORIO
                  </p>
                </div>
                <div className="form-group">
                  <label>Descripción</label>
                  <input
                    onChange={(e) =>
                      updateForm({ description: e.target.value })
                    }
                    value={dataForm.description}
                  />
                </div>
              </form>
            </div>
          </div>
        </PopupContainer>
      </Layout>
    );
  }

  return (
    <Container>
      <TopbarWindow>
        <button className="btn-primary ghost">
          <Link to="/app/analytics-dashboard">X</Link>
        </button>
        <h3>{dataForm.name}</h3>
        <button onClick={handleSave} className="btn btn-primary">
          Guardar Dashboard
        </button>
      </TopbarWindow>
      <div className="board-extra-container">
        <ToolbarWindow>
          <>
            {!optionsMenuActive &&
              items.map((item) => (
                <Tool
                  key={item.id}
                  draggable
                  onDragStart={(e) => handleDragStart(e, item.id)}
                >
                  <img
                    src={`/assets/${item.logo}`}
                    alt={`Logo ${item.label}`}
                    draggable="false"
                  />
                  <span>{item.label ? item.label : item.content}</span>
                </Tool>
              ))}
            {optionsMenuActive &&
              optionsIdActive.includes("Note") &&
              editItems.map((item) => (
                <Tool
                  key={item.id}
                  onClick={(e) => handleEditOption(e, item.label)}
                >
                  <img src="#" alt={`Logo ${item.label}`} />
                  <span>{item.label ? item.label : item.content}</span>
                </Tool>
              ))}
          </>
        </ToolbarWindow>
        <DropBoard onClick={handleClickOutside} ref={containerRef}>
          <div
            className="board"
            onDrop={(e) => handleDrop(e, "zone1")}
            onDragOver={handleDragOver}
            ref={contentRef}
            style={{
              height:
                calculateMaxHeight(memoizedDroppedItems) > window.innerHeight
                  ? calculateMaxHeight(memoizedDroppedItems)
                  : "calc(100% + 500px)",
              margin: "0 auto",
            }}
          >
            {memoizedDroppedItems.map((item, i) => (
              <CanvasElement
                key={item.id}
                id={item.id}
                label={item.label}
                x={item.x}
                y={item.y}
                width={item.width}
                height={item.height}
                handleMouseDown={handleMouseDown}
                handleTouchStart={handleTouchStart}
                handleResize={handleResize}
                handleRightClick={handleRightClick}
                handleLeftClick={(e) => {
                  const isNote = item.id.includes("Note");
                  if (isNote) {
                    handleLeftClick(e, item);
                  }
                }}
                boxShadow={false}
                handleImageSize={handleImageSize}
              >
                {React.cloneElement(item.content, {
                  listType: item.listType,
                  items: item.items || [],
                  data: item.data,
                })}
              </CanvasElement>
            ))}
          </div>
        </DropBoard>
      </div>
      {toolMenuVisible && (
        <ul
          className="context-menu"
          style={{
            position: "absolute",
            top: toolMenuPosition.y,
            left: toolMenuPosition.x,
            background: "#fff",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
            border: "1px solid #ccc",
            padding: "8px 0",
            listStyle: "none",
            zIndex: 1000,
          }}
          onClick={handleClickOutside}
        >
          {toolMenuPosition.itemId.includes("Table") &&
          !toolMenuPosition.itemId.includes("statisticsTable") ? (
            <>
              <li
                style={{ padding: "8px 16px", cursor: "pointer" }}
                onClick={(e) => {
                  handleAddRowColumnTable(e, "row");
                }}
              >
                Agregar fila
              </li>
              <li
                style={{ padding: "8px 16px", cursor: "pointer" }}
                onClick={(e) => {
                  handleAddRowColumnTable(e, "column");
                }}
              >
                Agregar columna
              </li>
            </>
          ) : null}
          <li
            style={{ padding: "8px 16px", cursor: "pointer" }}
            onClick={() => {
              setDroppedItems((prev) =>
                prev.filter((item) => item.id !== toolMenuPosition.itemId)
              );
              setToolMenuVisible(false);
            }}
          >
            Eliminar
          </li>
        </ul>
      )}
    </Container>
  );
};

export default DndDashboard;
